import React from 'react';
import PublicHeader from './PublicHeader';

const PublicLayoutWrapper = ({ children, title, subtitle, className = "", showBackToHome = true }) => {
    return (
        <div className={`min-h-screen bg-black ${className}`}>
            <PublicHeader
                title={title}
                subtitle={subtitle}
                showBackToHome={showBackToHome}
            />
            <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                {children}
            </main>
        </div>
    );
};

export default PublicLayoutWrapper;
